export const getIntervalCount = (startMonth) => {
  const months = [
    'JANUARY',
    'FEBRUARY',
    'MARCH',
    'APRIL',
    'MAY',
    'JUNE',
    'JULY',
    'AUGUST',
    'SEPTEMBER',
    'OCTOBER',
    'NOVEMBER',
    'DECEMBER',
  ];
  if (startMonth && months.includes(startMonth)) {
    const interval = Math.abs(new Date().getMonth() - months.indexOf(startMonth) + 1);
    return interval > 6 ? 6 : interval;
  }
  return 6;
};
